import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Sommeil = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.89 150.86">
  <G fill={color}>
    <Polygon points="5.25 124.15 14.11 124.15 4.81 146.49 4.81 150.86 19.14 150.86 19.14 146.41 9.84 146.41 19.14 124.06 19.14 119.7 5.25 119.7 5.25 124.15"/>
    <Polygon points="2.99 70.73 14.81 70.73 2.4 100.52 2.4 106.34 21.51 106.34 21.51 100.41 9.11 100.41 21.51 70.61 21.51 64.8 2.99 64.8 2.99 70.73"/>
    <Polygon points="23.89 0 .74 0 .74 7.42 15.5 7.42 0 44.66 0 51.93 23.89 51.93 23.89 44.51 8.38 44.51 23.89 7.27 23.89 0"/>
  </G>
</Svg>
);
};

export default Sommeil;
